import { parseSlideData, parseSliderConfig, startSliderAutoplay } from './slider';

require('owl.carousel');

const SLIDER_ROOT_KEY = 'media-slider';
const SLIDER_SLIDE_KEY = 'slide';
const SLIDER_TYPE = 'media';
let SLIDER_INDEX = 0;

export default class MediaSliderComponent {
  init() {
    jQuery(SLIDER_ROOT_KEY).each((i, el) => {
      this.render(el);
    });

    return this;
  }

  /**
   * Renders the History Slider
   * @param {HTMLElement} sliderElement
   */
  render(sliderElement) {
    SLIDER_INDEX = 1 + SLIDER_INDEX;
    const xml = sliderElement.outerHTML;
    const config = parseSliderConfig(sliderElement, SLIDER_TYPE);
    const sliderDom = jQuery(
      `<div class="slider media-slider owl-carousel owl-theme" id="history-slider--${SLIDER_INDEX}" />`,
    );

    jQuery(xml)
      .children(SLIDER_SLIDE_KEY)
      .each((j, slide) => {
        const data = parseSlideData(slide, SLIDER_TYPE);
        sliderDom.append(`
          <div class="slider__slide">
            <article class="article">
              <div class="article__image">
                <img src="${data.articleImage.trim()}" alt="${data.articleTitle}">
              </div>
              <div class="article__text-container">
                <div class="article__content">
                  <h5><a href='${data.articleLink}' target="_blank">${data.articleTitle}</a></h5>
                </div>
              </div>
            </article>
          </div>
        `);
      });

    jQuery(sliderElement).replaceWith(sliderDom);
    startSliderAutoplay(sliderDom);
    sliderDom.owlCarousel(config);
  }
}
